import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

export function fieldMessageId(id: string): string {
  return `${id}-message`;
}

function FieldMessage({ id, error, hint }: { id: string; error?: ReactNode; hint?: ReactNode }) {
  if (error) {
    return (
      <p id={fieldMessageId(id)} role="alert" className="text-destructive type-footnote">
        {error}
      </p>
    );
  }
  if (hint) {
    return (
      <p id={fieldMessageId(id)} className="text-muted-foreground type-footnote">
        {hint}
      </p>
    );
  }
  return null;
}

export function Field({
  id,
  label,
  optional,
  hint,
  error,
  children,
  className,
}: {
  id: string;
  label: string;
  optional?: boolean;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("space-y-2", className)}>
      <label htmlFor={id} className="flex items-baseline justify-between gap-3 text-[14px] font-medium">
        {label}
        {optional && <span className="text-muted-foreground text-[13px] font-normal">Optional</span>}
      </label>
      {children}
      <FieldMessage id={id} error={error} hint={hint} />
    </div>
  );
}
